export const RequestHeader = {
    ACCEPT: "Accept",
    CONTENT_TYPE: "Content-Type",
    AUTHORIZATION: "Authorization",
};

export const RequestMethod = {
    PUT: "PUT",
    POST: "POST",
    DELETE: "DELETE",
    PATCH: "PATCH",
};

export const ContentType = {
    PDF: "application/pdf",
    OCTET_STREAM: "application/octet-stream",
    JSON: "application/json",
    FORM_DATA: "multipart/form-data",
    CONTENT_DISPOSITION: "content-disposition",
};
